import auth from 'auth'
import dayjs from 'dayjs'
import { browserName, browserVersion, osName, osVersion } from 'react-device-detect'
import { getClientLocale, getClientTimezone } from 'libs/tracking-client-utils'

/**
 * @typedef {import('hooks/useSaveUserActivityLog').ACTION_NAME} ACTION_NAME
 *
 * @typedef {object} UserActivityLog
 * @property {keyof typeof import('hooks/useSaveUserActivityLog').ACTION_NAME | string} action
 * @property {string} target
 * @property {object=} requestBody
 * @property {object=} errorResponseBody
 * @property {number} statusCode
 *
 * @param {UserActivityLog} log
 */
export default function generateUserActivityLog({
  action,
  target,
  requestBody = null,
  errorResponseBody = null,
  statusCode = 200,
}) {
  const userInfo = auth.getUserInfoFromToken()
  const companyId = userInfo?.company?.id
  const userId = userInfo?.user_id
  const actor = `usr_${userId}`
  const company = `com_${companyId}`
  const currentTimeUTC = dayjs().toISOString()
  const created = currentTimeUTC
  const browser = osName + ' ' + osVersion + ' / ' + browserName + ' ' + browserVersion
  const locale = getClientLocale()
  const timezone = getClientTimezone()

  const log = {
    action,
    actor,
    target,
    company,
    created,
    data: requestBody,
    ...(errorResponseBody ? { error_response_body: errorResponseBody } : {}),
    status_code: statusCode,
    pk: `${company}|${actor}`,
    sk: `${created}|${target}|${action}`,
    browser,
    locale,
    timezone,
  }

  return log
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/libs/generateUserActivityLog/index.js